import React, {useState } from 'react'
import { Box, Grid,TextField, Typography, Paper, Button } from '@mui/material'
import HeaderBox from '../../../components/HeaderBox';
import PrintIcon from '@mui/icons-material/Print';
import buttonStyle from '../../../styles/buttonStyle'
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from "react-to-print";
import { useRef } from 'react';
import AddLabourTask from '../../../components/estimate/AddLabourTask';
import AddPartsTask from '../../../components/estimate/AddPartsTask';
// import ParentLabour from '../../task/ParentLabour';
// import { labour } from '../../../data/LabourData';
// import { parts } from '../../../data/PartsData';
// import FirstChild from '../../task/FirstChild';
// import SecondChild from '../../task/SecondChild';

const firstLabourRow = {
    description: "",
    id: 1,
    hrRate: 40,
    hrs: 1,
    actualHr: 1,
    vat: '20.00',
    tradeRate: "",
    amt: "",
    labourId: null
}

const firstPartsRow = {
    description: "",
    id: 1,
    costRate: 45,
    qty: 1,
    markup: 10,
    vat: '20.00',
    trade: "",
    amt: "",
    partsId: null
}
  
    


const boxStyle = {
  root: {
    backgroundColor: 'white', 
    borderRadius: '5px',
    padding: 1
  },
};

function EstimateBill() {
    const navigate = useNavigate()
    const conponentPDF= useRef();
    const generatePDF= useReactToPrint({
        content: ()=>conponentPDF.current,
        documentTitle:"Userdata",
        onAfterPrint:()=>alert("Data saved in PDF")
    });
    // const [firstChild, setFirstChild] = useState()
    // const [ setSecondChildren] = useState()
    // const [ setParentName] = useState()
    const [checked, setChecked] = useState([]);
    const [checkedParts, setCheckedParts] = useState([]);
    // const [setFChild] = useState(false)
    // const [setSChild] = useState(false)
    // const [ setCustomer] = useState(false)
    // const [ setVehicle] = useState(false)
    const [disc, setDisc] = useState(0)
    const [vat, setVat] = useState(20)

    // const [ setOpen] = useState(false);

    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    //     setCustomer(false)
    //     setVehicle(false)
    // };

    // const handleParent = (id, label) => {
    //     const newChildren = labour.find(item => item.id === id).children
    //     setParentName(label)
    //     setFirstChild(newChildren)
    //     setFChild(true)
    // }
    // const handleChild = (id, label) => {
    //     setFChild(false)
    //     setSChild(true)
    //     const newChildren = firstChild.find(item => item.id === id).children
    //     setParentName(label)
    //     setSecondChildren(newChildren)
    // }

    // const handleToggle = (value, item) => {
    //     const currentIndex = checked.indexOf(value);
    //     const newChecked = [...checked];

    //     const currentIndexParts = checkedParts.indexOf(value);
    //     const newCheckedParts = [...checkedParts];

    //     if (currentIndex === -1) {
    //         newChecked.push(value);
    //         addRow(item)
    //     } else {
    //         newChecked.splice(currentIndex, 1);
    //         deleteRow(value)
    //     }
    //     setChecked(newChecked);

    //     if (currentIndexParts === -1) {
    //         const partsItem = parts.filter(part => part.pid === value)
    //         newCheckedParts.push(value);
    //         addRowParts(partsItem)
    //     } else {
    //         newCheckedParts.splice(currentIndexParts, 1);
    //         deleteRowParts(value, null)
    //     }
    //     setCheckedParts(newCheckedParts);
    // };

    const handleDelete = (id) => {
        const currentIndex = checked.indexOf(id);
        const newChecked = [...checked];
        newChecked.splice(currentIndex, 1);
        setChecked(newChecked);

        const currentIndexParts = checkedParts.indexOf(id);
        const newCheckedParts = [...checkedParts];
        newCheckedParts.splice(currentIndexParts, 1);
        setCheckedParts(newCheckedParts);
    };

    const [rows, setRows] = useState([]);
    const [rowsPart, setRowsPart] = useState([]);

    const addRow = (field) => {    
        const newRow = { ...firstLabourRow, id: rows.length + 1, description: field.label, labourId: field.id, amt: firstLabourRow.actualHr * firstLabourRow.hrRate }; // Modify as needed
        setRows([...rows, newRow]);
    };

    // const deleteRow = (id) => {
    //     const updatedRows = rows.filter((row) => row.labourId !== id);
    //     const updatedRowsWithConsecutiveIDs = updatedRows.map((row, index) => ({
    //         ...row,
    //         id: index + 1,
    //     }));

    //     setRows(updatedRowsWithConsecutiveIDs);
    // };

    const addRowParts = (partItems) => {
        console.log(partItems);
        let currentId = rowsPart.length + 1;
        const modifiedData = partItems.map((item) => ({
            ...firstPartsRow,
            id: currentId++,
            description: item.label,
            partsId: item.pid,
            trade: (firstPartsRow.costRate * (firstPartsRow.markup / 100)) + firstPartsRow.costRate,
            amt: ((firstPartsRow.costRate * (firstPartsRow.markup / 100)) + firstPartsRow.costRate) * firstPartsRow.qty,

        }))
        console.log(modifiedData);
        setRowsPart([...rowsPart, ...modifiedData]);
    };

    const deleteRowParts = (id, del) => {
        console.log(id, rowsPart);
        const updatedRows = rowsPart.filter((row) => row.partsId !== id);
        const updatedRowsDel = rowsPart.filter((row) => row.id !== id);

        // After filtering, reassign consecutive IDs to the rows
        const updatedRowsWithConsecutiveIDs = del ? updatedRowsDel.map((row, index) => ({
            ...row,
            id: index + 1,
        })) :
            updatedRows.map((row, index) => ({
                ...row,
                id: index + 1,
            }));

        setRowsPart(updatedRowsWithConsecutiveIDs);
    };

    const calculateTotalAmount = () => {
        const totalLabourAmount = rows.reduce((accumulator, row) => {
            return accumulator + parseFloat(row.amt || 0);
        }, 0);
        const totalPartsAmount = rowsPart.reduce((accumulator, row) => {
            return accumulator + parseFloat(row.amt || 0);
        }, 0);
        return totalLabourAmount + totalPartsAmount;
    };


    const calculateDiscountedAmount = () => {
        const totalAmount = calculateTotalAmount();
        return totalAmount - (totalAmount * (disc / 100));
    };

    const calculateVATAmount = () => {
        const discountedAmount = calculateDiscountedAmount();
        return discountedAmount * (vat / 100);
    };

    const calculateNetTotal = () => {
        const discountedAmount = calculateDiscountedAmount();
        const vatAmount = calculateVATAmount();
        return (discountedAmount + vatAmount);
    };

    // const [isParts, setIsParts] = useState(false)
    return (
      <Box mt={2} >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                  {" "}
                  ESTIMATE BILL
                </Typography>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <Button sx={buttonStyle.root} onClick={generatePDF}>
                  <PrintIcon />
                  Print
                </Button>
                &nbsp;
                <Button
                  sx={buttonStyle.root}
                  onClick={() => navigate("/estimate_task")}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <Grid item xs={12} mt={1}>
              <Box>
                <form>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <HeaderBox title="Estimate" />
                    </Grid>
                    <Grid item xs={12}>
                      <Box sx={boxStyle.root}>
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            {" "}
                            Unit 1.71-73{" "}
                          </Grid>
                          <Grid item xs={12}>
                            {" "}
                            Nathan Way{" "}
                          </Grid>
                          <Grid item xs={12}>
                            {" "}
                            Thamesmead{" "}
                          </Grid>
                          <Grid item xs={12}>
                            {" "}
                            London{" "}
                          </Grid>
                          <Grid item xs={12}>
                            {" "}
                            SE280BQ{" "}
                          </Grid>
                          <Grid item xs={12}>
                            {" "}
                            0208 854 8382{" "}
                          </Grid>
                          <Grid item xs={12}></Grid>
                          <Grid item xs={12} fontWeight="bold">
                            {" "}
                            Mr John{" "}
                          </Grid>
                          <Grid item xs={12}></Grid>
                          <Grid item xs={12} sm={6} md={1.5} fontWeight="bold">
                            {" "}
                            AccNo :{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={1.5}>
                            {" "}
                            ACC01557{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={1.5} fontWeight="bold">
                            {" "}
                            OrderNo :
                          </Grid>
                          <Grid item xs={12} sm={6} md={1.5}>
                            {" "}
                            256
                          </Grid>
                          <Grid item xs={12} sm={6} md={1.5} fontWeight="bold">
                            {" "}
                            Auth No :{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={1.5}>
                            {" "}
                            658{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={1.5} fontWeight="bold">
                            {" "}
                            Mileage :{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={1.5}>
                            {" "}
                            50{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={3} fontWeight="bold">
                            {" "}
                            Registration Number{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={1}>
                            {" "}
                            LX2586{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={3} fontWeight="bold">
                            {" "}
                            Vehicle Description :{" "}
                          </Grid>
                          <Grid item xs={12} sm={6} md={5}>
                            LAND ROVER RANGE ROVER EVOQUE{" "}
                          </Grid>
                          <Grid item xs={12}></Grid>
                          <Grid item xs={12} fontWeight="bold">
                            {" "}
                            04-Sep-2023{" "}
                          </Grid>
                          <Grid item xs={12} p={2}>
                            {" "}
                            15:22 - 15:55{" "}
                          </Grid>
                          <Grid item xs={12}>
                            <Box mt={1}>
                              <Grid container spacing={1}>

                                <Grid item xs={12}>
                                  <HeaderBox title="Estimate Calculation" />
                                  <Paper sx={{ p: 1, mt: 1 }}>
                                    <Box>
                                      <AddLabourTask
                                        rows={rows}
                                        setRows={setRows}
                                        addRow={addRow}
                                        handleDelete={handleDelete}
                                        deleteRowParts={deleteRowParts}
                                      />
                                    </Box>
                                    <Box mt={2}>
                                      <AddPartsTask
                                        rowsPart={rowsPart}
                                        setRowsPart={setRowsPart}
                                        addRowParts={addRowParts}
                                        deleteRowParts={deleteRowParts}
                                      />
                                    </Box>
                                    <Box mt={2}>
                                      <Grid container spacing={1}>
                                        <Grid item xs={5}>
                                          <TextField
                                            id="outlined-multiline-static"
                                            label="Suggestions"
                                            multiline
                                            rows={5}
                                            fullWidth
                                          />
                                        </Grid>

                                        <Grid item xs={7}>
                                          <Box>
                                            <Grid container spacing={1}>
                                              <Grid
                                                item
                                                xs={12}
                                                display="flex"
                                                justifyContent="space-between"
                                              >
                                                <Typography>
                                                  Taxable Amount
                                                </Typography>
                                                <Typography>
                                                  {calculateTotalAmount().toFixed(
                                                    2
                                                  )}
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                xs={12}
                                                display="flex"
                                                justifyContent="space-between"
                                              >
                                                <Box
                                                  display="flex"
                                                  justifyContent="space-between"
                                                >
                                                  <Typography>
                                                    Discount %
                                                  </Typography>
                                                  &nbsp;&nbsp;
                                                  <TextField
                                                    // fullWidth
                                                    style={{ width: "60px" }}
                                                    InputProps={{
                                                      style: { height: "20px" },
                                                    }}
                                                    size="small"
                                                    variant="outlined"
                                                    required
                                                    name="estimateDate"
                                                    value={disc}
                                                    onChange={(e) =>
                                                      setDisc(e.target.value)
                                                    }
                                                  />
                                                </Box>

                                                <Typography>
                                                  {(
                                                    calculateTotalAmount() *
                                                    (disc / 100)
                                                  ).toFixed(2)}
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                xs={12}
                                                display="flex"
                                                justifyContent="space-between"
                                              >
                                                <Typography>
                                                  Discounted Amount
                                                </Typography>
                                                <Typography>
                                                  {calculateDiscountedAmount().toFixed(
                                                    2
                                                  )}
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                xs={12}
                                                display="flex"
                                                justifyContent="space-between"
                                              >
                                                <Box
                                                  display="flex"
                                                  justifyContent="space-between"
                                                >
                                                  <Typography>VAT %</Typography>
                                                  &nbsp;&nbsp;
                                                  <TextField
                                                    // fullWidth
                                                    style={{ width: "60px" }}
                                                    InputProps={{
                                                      style: { height: "20px" },
                                                    }}
                                                    size="small"
                                                    variant="outlined"
                                                    required
                                                    name="estimateDate"
                                                    value={vat}
                                                    onChange={(e) =>
                                                      setVat(e.target.value)
                                                    }
                                                  />
                                                </Box>
                                                <Typography>
                                                  {calculateVATAmount().toFixed(
                                                    2
                                                  )}
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                xs={12}
                                                display="flex"
                                                justifyContent="space-between"
                                              >
                                                <Typography>
                                                  Net Total
                                                </Typography>
                                                <Typography>
                                                  {calculateNetTotal().toFixed(
                                                    2
                                                  )}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Box>
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  </Paper>
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>

                    {/* {/* <Grid item xs={12}>
                  <HeaderBox title='PARTS' isOpen={isParts} setIsOpen={setIsParts}/>
                </Grid> */
                    /* <Grid item xs={12} >
                <SingleAccordion component={<AddPartsTable/>} title='Labour Tasks'/>
                </Grid>
                <Grid item xs={12} >
                  <SingleAccordion component={<AddPartsTable/>} title=' Spare Parts'/>
                </Grid>
                <Grid item xs={12} >
                  <SingleAccordion component={<Complaint/>} title='Suggestion'/>
                </Grid>
                <Grid item xs={12} >
                    <SingleAccordion component={<Complaint/>} title='Complaint'/>
                </Grid> */}
                  </Grid>
                </form>
              </Box>
            </Grid>
          </div>
        </Grid>
      </Box>
    );
  }

export default EstimateBill